import React from "react";
import { Link } from "react-router-dom";
import Icon from "./OBJECT.svg"; // You might want to use a different icon for 404

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center flex-1 p-4 text-center">
      <img src={Icon} alt="page not found icon" />
      <h1 className="text-2xl font-bold text-center mt-4">
        404 - БҰНДАЙ БЕТ ТАБЫЛМАДЫ
      </h1>
      <p className="text-center text-lg text-gray-700 max-w-3xl mt-2">
        Кешіріңіз, сіз іздеген бет табылмады. Бет өшірілген, жылжытылған немесе
        мекенжайы қате енгізілген болуы мүмкін. Басты бетке оралып, қажетті
        бөлімді қайта іздеп көріңіз.
      </p>

      <Link
        to="/"
        className="bg-[#F3DA6D] text-base text-[#674DA2] py-2 px-10 rounded-xl mt-10 uppercase inline-block hover:bg-yellow-500 transition-colors"
      >
        БАСТЫ БЕТКЕ ОРУ
      </Link>
    </div>
  );
};

export default NotFound;
